// 'use strict';

var AudioSample = require('./AudioSample.js');


var remap = THREE.Math.mapLinear;
var clamp = THREE.Math.clamp;

module.exports = function( options ){

  options = options || {};

  var ctx = Tone.context;

  // var popSound = new AudioSample('assets/Tick.mp3')
  var popSound = new AudioSample('assets/Blop.mp3')

  var limiter = new Tone.Limiter(0).toMaster();

  var gain = new Tone.Volume( 0 ).connect( limiter );
  gain.set( 'volume',  -10 );

  var leftPos = new THREE.Vector3( 350, 0, 0);
  var rightPos = new THREE.Vector3(-350, 0, 0 );

  var mergerNode = ctx.createChannelMerger(2);
  mergerNode.connect(gain);

  var leftGain = ctx.createGain().connect(mergerNode, 0, 0);
  var rightGain = ctx.createGain().connect(mergerNode, 0, 1);

  var threshold = 600;

  return {
    gain: gain,

    pop: function( b, gainScale ){

      var source = popSound.play();

      if( source.detune ){
        source.detune.value = THREE.Math.mapLinear(b.radius, 5, 70, 100, -100 );
      } else {
        source.playbackRate.value = THREE.Math.mapLinear(b.radius, 5, 70, 4, 0.4 )
      }

      var deltaLeft = leftPos.distanceTo(b.position);
      var deltaRight = rightPos.distanceTo(b.position);

      var lval = remap(deltaLeft, 0, threshold, 0.4, -0.4);
      var rval = remap(deltaRight, 0, threshold, 0.4, -0.4);

      if(lval > 0 ){
        var lg = ctx.createGain();
        lg.gain.value = clamp(lval, 0, 1);
        lg.connect(mergerNode, 0, 0);
        source.connect(lg);
      }

      if(rval > 0){
        var rg = ctx.createGain();
        rg.gain.value = clamp(rval, 0, 1);
        rg.connect(mergerNode, 0, 1);        
      
        source.connect(rg);
      }

    },

    burst: function( b, gainScale ){

      var source = popSound.play();

      if( source.detune ){
        source.detune.value = THREE.Math.mapLinear(b.radius, 5, 70, 1000, 0 );
      } else {
        source.playbackRate.value = THREE.Math.mapLinear(b.radius, 5, 70, 4, 0.4 )
      }

      var deltaLeft = leftPos.distanceTo(b.position);
      var deltaRight = rightPos.distanceTo(b.position);

      var lval = remap(deltaLeft, 0, threshold, 1, 0.1);
      var rval = remap(deltaRight, 0, threshold, 1, 0.1);

      if(lval > 0 ){
        var lg = ctx.createGain();
        lg.gain.value = clamp(lval, 0.25, 1);
        lg.connect(mergerNode, 0, 0);
        source.connect(lg);
      }

      if(rval > 0){
        var rg = ctx.createGain();
        rg.gain.value = clamp(rval, 0.25, 1);
        rg.connect(mergerNode, 0, 1);        
      
        source.connect(rg);
      }

    }
  }

}